import { useState, useCallback } from 'react';

export const useToggleSet = (initialItems = []) => {
  const [items, setItems] = useState(new Set(initialItems));

  const toggle = useCallback((item) => {
    setItems((prev) => {
      const next = new Set(prev);
      if (next.has(item)) {
        next.delete(item);
      } else {
        next.add(item);
      }
      return next;
    });
  }, []);

  const has = useCallback((item) => items.has(item), [items]);

  const clear = useCallback(() => setItems(new Set()), []);

  const add = useCallback((item) => {
    setItems((prev) => new Set([...prev, item]));
  }, []);

  const remove = useCallback((item) => {
    setItems((prev) => {
      const next = new Set(prev);
      next.delete(item);
      return next;
    });
  }, []);

  return { items, toggle, has, clear, add, remove };
};
